import {
  Box,
  Flex,
  SimpleGrid,
  Text,
  Select,
  HStack,
  Button,
} from "@chakra-ui/react";
import NewImg from "@/assets/images/creator_img3.png";
import EchartsComponent, {
  MyChartOptions,
} from "@/components/echartsComponent";
import { WorkInfo } from "@/types/creatorcenter";
import { useState } from "react";

const RealizationCenter = () => {
  const [currentIncomeNav, setCurrentIncomeNav] = useState<string>("近7日");

  const handleIncomeNav = (title: string) => {
    setCurrentIncomeNav(title);
  };
  // 图表配置项
  const incomeDatalineOption: MyChartOptions = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
      },
      padding: [5, 10],
    },
    // legend: {
    //   data: ['销量'],
    // },
    xAxis: {
      data: ["04/07", "04/07", "04/07", "04/07", "04/07", "04/07", "04/07"],
      show: true,
      boundaryGap: false,
      axisLabel: {
        interval: 0, // 强制显示所有标签
        showMaxLabel: true,
        margin: 10,
      },
      axisTick: {
        show: false,
      },
    },
    yAxis: {
      axisLabel: {
        // 使用 formatter 函数来格式化标签文本
        formatter: "{value} 人", // 这里的 '{value} 人' 就是标签加上了单位 "人"
        margin: 20, // 设置刻度标签距离轴的距离为20
      },
      axisTick: {
        show: false,
      },
    },
    grid: {
      left: 0,
      right: 30,
      bottom: 0,
      top: 10,
      containLabel: true, // 是否包含坐标轴的标签
    },
    series: [
      {
        name: "收入",
        type: "line",
        // smooth: true,
        data: [1, 244, 699, 10, 107, 20, 321],
        animationDuration: 2800,
        animationEasing: "cubicInOut",
      },
    ],
  };

  return (
    <Box h="100%" pl="20px" pr="20px" overflow={"auto"}>
      <Box flex={1} borderWidth="1px" borderColor={"#DCE0EB"} p="20px">
        <Box mb="20px" fontSize={"18px"} fontWeight="bold" color={"#27314D"}>
          我的收入
        </Box>
        <Flex gap={"20px"}>
          <Box flex={1} bg="linear-gradient(90deg, #FEF8EF 0%, #FCF2E4 100%)">
            <Box
              h="100%"
              p="18px"
              alignItems={"center"}
              boxSizing="border-box"
              gap={"10px"}
            >
              <Box
                color={"#27314D"}
                fontSize={"16px"}
                fontWeight="500"
                mb={"5px"}
              >
                收入总金额
              </Box>
              <Box color={"#8E94A9"} fontSize={"12px"}>
                ¥0.00
              </Box>
            </Box>
          </Box>
          <Box flex={1} bg="linear-gradient(90deg, #F2F8FC 0%, #CFDCEA 100%)">
            <Box
              h="100%"
              p="12px"
              alignItems={"center"}
              boxSizing="border-box"
              gap={"10px"}
            >
              <Box
                color={"#27314D"}
                fontSize={"16px"}
                fontWeight="500"
                mb={"5px"}
              >
                可提现金额
              </Box>
              <HStack spacing={"20px"}>
                <Box color={"#8E94A9"} fontSize={"12px"}>
                  ¥******
                </Box>
                <Button
                  borderRadius={"0px"}
                  width={"73px"}
                  height={"30px"}
                  color="#FFFFFF"
                  bgColor="#496AE1"
                  fontWeight={"normal"}
                  fontSize="12px"
                  _hover={{
                    bgColor: "#3F5BC1",
                    color: "#E6E6E6",
                  }}
                >
                  去提现
                </Button>
              </HStack>
            </Box>
          </Box>
        </Flex>
      </Box>
      <Box borderWidth="1px" borderColor={"#DCE0EB"} p="20px" mt="20px">
        <Flex
          mb="20px"
          justifyContent={"space-between"}
          alignItems="center"
          borderBottom={"1px solid #CBD1DF"}
        >
          <Box
            fontSize={"16px"}
            color={"#27314D"}
            borderColor="#27314D"
            borderBottom={"4px"}
          >
            全部内容
          </Box>
        </Flex>

        <Flex mb="20px" justifyContent={"space-between"}>
          <Box fontSize={"18px"} fontWeight="bold" color={"#27314D"}>
            收入总览
          </Box>
        </Flex>
        <Flex gap={"2px"}>
          <Box
            flex={1}
            h="107px"
            p="16px 20px"
            bgColor={ currentIncomeNav === "昨日" ? "none" : "rgba(238, 241, 247, 0.5)"}
            borderTop={currentIncomeNav === "昨日" ? "5px solid #496AE1" : "none"}
            onClick={() => handleIncomeNav("昨日")}
          >
            <Box fontSize={"10px"} color={currentIncomeNav === "昨日" ? "#496AE1" : "#27314D"} mb="8px">
              昨日
            </Box>
            <Box fontSize={"20px"} color="#27314D" fontWeight={"500"} mb="8px">
              ￥0.00
            </Box>
            <Flex
              justifyContent={"space-between"}
              fontSize={"10px"}
              color="#27314D"
            >
              <Text>较前日</Text>
              <Text>0.00</Text>
            </Flex>
          </Box>
          <Box
            flex={1}
            h="107px"
            p="16px 20px"
            bgColor={ currentIncomeNav === "近7日" ? "none" : "rgba(238, 241, 247, 0.5)"}
            borderTop={currentIncomeNav === "近7日" ? "5px solid #496AE1" : "none"}
            onClick={() => handleIncomeNav("近7日")}
          >
            <Box fontSize={"10px"} color={currentIncomeNav === "近7日" ? "#496AE1" : "#27314D"} mb="8px">
              近7日
            </Box>
            <Box fontSize={"20px"} color="#27314D" fontWeight={"500"} mb="8px">
              ￥0.00
            </Box>
            <Flex
              justifyContent={"space-between"}
              fontSize={"10px"}
              color="#27314D"
            >
              <Text>较前7日</Text>
              <Text>0.00</Text>
            </Flex>
          </Box>
          <Box
            flex={1}
            h="107px"
            p="16px 20px"
            bgColor={ currentIncomeNav === "近30日" ? "none" : "rgba(238, 241, 247, 0.5)"}
            borderTop={currentIncomeNav === "近30日" ? "5px solid #496AE1" : "none"}
            onClick={() => handleIncomeNav("近30日")}
          >
            <Box fontSize={"10px"} color={currentIncomeNav === "近30日" ? "#496AE1" : "#27314D"} mb="8px">
              近30日
            </Box>
            <Box fontSize={"20px"} color="#27314D" fontWeight={"500"} mb="8px">
              ￥0.00
            </Box>
            <Flex
              justifyContent={"space-between"}
              fontSize={"10px"}
              color="#27314D"
            >
              <Text>较前30日</Text>
              <Text>0.00</Text>
            </Flex>
          </Box>
          <Box
            flex={1}
            h="107px"
            p="16px 20px"
            bgColor={ currentIncomeNav === "全部累计" ? "none" : "rgba(238, 241, 247, 0.5)"}
            borderTop={currentIncomeNav === "全部累计" ? "5px solid #496AE1" : "none"}
            onClick={() => handleIncomeNav("全部累计")}
          >
            <Box fontSize={"10px"} color={currentIncomeNav === "全部累计" ? "#496AE1" : "#27314D"} mb="8px">
              全部累计
            </Box>
            <Box fontSize={"20px"} color="#27314D" fontWeight={"500"} mb="8px">
              ￥0.00
            </Box>
          </Box>
        </Flex>
        <Flex mt={"40px"} mb="20px">
          <Box fontSize={"18px"} fontWeight="bold" color={"#27314D"}>
            数据趋势
          </Box>
        </Flex>
        {currentIncomeNav === "近7日" &&  (
          <Box h="240px">
            <EchartsComponent chartsOption={incomeDatalineOption} />
          </Box>
        )}
        
      </Box>
    </Box>
  );
};

export default RealizationCenter;
